import React, { useId } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './ExamsCovered.module.scss';

function ExamsCovered({ items, slideCount }) {
  const id = useId();

  if (!items?.length) return null;

  return (
    <div className={styles.wrapper}>
      <Swiper
        id={id}
        slidesPerView={2}
        spaceBetween={20}
        slidesOffsetBefore={5}
        slidesOffsetAfter={5}
        breakpoints={{
          460: {
            slidesPerView: slideCount,
          },
        }}
      >
        {items.map((item) => (
          <SwiperSlide key={item.id}>
            <div className={styles.exam}>
              <span className={styles.examTitle}>{item?.examCovered}</span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default ExamsCovered;
